import { genPanelityImport } from "_services";
import { ButtonExcelForQuick, CommonInput, ExcelDownload, Heading } from "components";
import { utils } from "helper";
import React, { useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import StorageService from "utils/StorageServices";
import * as Yup from "yup";

const GanPanelityUpload = () => {

     const initi = {
        company_id: StorageService.getCompanyId(),
        // firm_id:StorageService.getFirmId() || "",
        file: null,

    };

    const headers = [
        { name: "Late Delivery", value: "Late Delivery" },
        { name: "Short Value", value: "Short Value" },
        { name: "Actule Value", value: "Actule Value" },
        { name: "Dented", value: "Dented" },
        { name: "Cut Open Value", value: "Cut Open Value" },
    ];

    const navigate = useNavigate()

    const [form, setForm] = useState(initi);
    const [formError, setFormError] = useState("");
    const [loading, setLoading] = useState(false);
    const [addressInportList, setAddressInportList] = useState([])
    const [tableData, setTableData] = useState([])
    const [statusCounts, setStatusCounts] = useState({
        Rejected: 0,
        Updated: 0,
        Added: 0,
        All: 0,
    });
    const fileSchema = {
        uploadFileSchema: Yup.object().shape({

            file: Yup.mixed().required("File is required"),

        }),
    }


    const handleOnChange = async (name, value) => {

        setForm((prevForm) => {
            const updatedForm = {
                ...prevForm,
                [name]: value,
            };

            if (formError) {
                utils
                    .checkFormError(
                        {
                            ...updatedForm,
                        },
                        fileSchema?.uploadFileSchema
                    )
                    .then((validationResult) => {
                        if (validationResult === true) {
                            setFormError("");
                        } else {
                            setFormError(validationResult);
                        }
                    });
            }

            return updatedForm;
        });
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const validTypes = [
                "text/csv",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            ];
            if (validTypes.includes(file.type)) {
                handleOnChange("file", file);
                setFormError({
                    ...formError,
                    file: "",
                });
            } else {
                setFormError({
                    ...formError,
                    file: "Please upload only CSV or XLSX files.",
                });
            }
        }
    };

    const handleImportFile = async () => {

        const formData = new FormData();
        Object.keys(form).forEach((key) => {
            if (key === "file" && form[key]) {
                formData.append(key, form[key]);
            } else {
                formData.append(key, form[key]);
            }
        });

        const validationResult = await utils.checkFormError(
            { ...form },
            fileSchema?.uploadFileSchema
        );

        if (validationResult == true) {
            setLoading(true);
            try {
                const res = await genPanelityImport(formData);
                if (res?.responseCode == 200) {

                    setLoading(false);

                    toast?.success(res?.responseMessage);

                    const execleDat = res?.data?.results?.map((i) => {

                        const remarkData = {};

                        // If expenses_status is empty → fill all headers with "-"
                        if (!i?.expenses_status || i?.expenses_status.length === 0) {
                            headers.forEach(header => {
                                remarkData[header.value] = "-";
                            });
                        } else {
                            // Fill remarks dynamically based on status
                            headers.forEach((header, index) => {
                                const statusObj = i?.expenses_status[index];
                                remarkData[header.value] = statusObj && statusObj.status === "Added" ? statusObj.remarks : "-";
                            });
                        }

                        // const copyForTable = {
                        //     "indent_number": i?.value?.indent_number,
                        //     "trip_number": i?.value?.trip_data?.trip_number,
                        //     "purchasing_document": i?.value?.purchasing_document,
                        //     // "late_delivery_amount": i?.value?.late_delivery_amount,
                        //     "status": i?.status,
                        //     "remark": i?.remarks,
                        //     ...remarkData

                        // }

                        //  setTableData([...copyForTable])

                        return {
                            "indent_number": i?.value?.indent_number,
                            "trip_number": { trip_number: i?.value?.trip_data?.trip_number, _id: i?.value?.trip_data?._id },
                            "purchasing_document": i?.value?.purchasing_document,
                            // "late_delivery_amount": i?.value?.late_delivery_amount,
                            "status": i?.status,
                            "remark": i?.remarks,
                            ...remarkData

                        }
                    })

                    const counts = res?.data?.results.reduce(
                        (acc, item) => {
                            if (item.status === 'Not Updated') acc.Rejected++;
                            if (item.status === 'Updated') acc.Updated++;
                            if (item.status === 'Added') acc.Added++;
                            acc.All++;
                            return acc;
                        },
                        { Rejected: 0, Updated: 0, Added: 0, All: 0 }
                    );

                    const tableData = execleDat.map((item) => ({
                        ...item,
                        trip_number: item?.trip_number?.trip_number || "-"  // show only trip number in table
                    }));

                    // ✅ Set table data once after mapping
                    setTableData(tableData);
                    setStatusCounts(counts);
                    // setTableData([...execleDat])
                    setAddressInportList(execleDat)
                } else {
                    setLoading(false);
                }
            } catch (error) {
                toast.error(error);
            }
        } else {
            setFormError(validationResult);
        }
    };

    return (
        <>
            <Heading title="Parle GAN Penalty Report Upload" download="Gain_Panelity" />

            <div className="_Qwk_inr">

                <div className="_exceluploadBx">
                    <CommonInput
                        type="file"
                        onChange={handleFileChange}
                        accept=".csv, .xlsx"
                        error={formError?.file}
                    />
                </div>
                <ButtonExcelForQuick name="Gain_penalty" />
                <button className="_flUpload_btn" disabled={loading} onClick={() => handleImportFile()}>{loading ? "Uploading.." : "Upload File"}</button>
            </div>

            {addressInportList?.length > 0 && <div className="tbdFilts_bx">
                <div className="_hedFilts">
                    <h4>Status</h4> <ExcelDownload tableData={tableData} />
                </div>

                <div className="_tbdOx_bx">
                    <div className="_fourTbx">
                        <h4>{statusCounts?.All}</h4>
                        <p className="__successTxt">All</p>
                    </div>

                    <div className="_fourTbx">
                        <h4>{statusCounts?.Added}</h4>
                        <p className="__successTxt">Added</p>
                    </div>

                    <div className="_fourTbx">
                        <h4>{statusCounts?.Updated}</h4>
                        <p className="__successTxt">Updated</p>
                    </div>

                    <div className="_fourTbx">
                        <h4>{statusCounts?.Rejected}</h4>
                        <p className="__rejectTxe">Not Updated</p>
                    </div>
                </div>
            </div>}

            {addressInportList?.length > 0 && <div className="_qwkTable_dix">
                <div className="_indentTable _disPatchView _fuelCrd__table">
                    <table>
                        <thead>
                            <tr>

                                <th>Indent Number</th>
                                <th>Trip Number</th>
                                <th>Purchasing Document</th>
                                <th>Late Delivery Value</th>
                                <th>Short value</th>
                                <th>Actual Value</th>
                                <th>Dented Value</th>
                                <th>Cut Open Value</th>
                                <th>Status</th>
                                <th>Remarks</th>
                            </tr>
                        </thead>

                        <tbody>
                            {addressInportList?.length && addressInportList?.map((i) => {

                                return <tr>

                                    <td>
                                        <div className="_dateNtime _pDate" onClick={() => window.open(`/trip/addtrip/dispatched/${i?.trip_number?._id}`, "_blank")}>
                                            <p className="_tblText_inDent">{i?.indent_number || ""}</p>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="_dateNtime _pDate" onClick={() => window.open(`/trip/addtrip/dispatched/${i?.trip_number?._id}`, "_blank")}>
                                            <p className="_tblText_inDent">{i?.trip_number?.trip_number || ""}</p>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="_dateNtime _pDate">
                                            <p className="_tblText_inDent">{i?.purchasing_document || ""}</p>
                                        </div>
                                    </td>
                                    {/* <td>
                                        <div className="_dateNtime _pDate"><p className="_tblText_inDent">{i?.late_delivery_amount || ""}</p></div>

                                    </td> */}
                                    <td>
                                        <div className="_dateNtime _pDate">
                                            <p className="_tblText_inDent">{i["Late Delivery"] || ""}</p>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="_dateNtime _pDate">
                                            <p className="_tblText_inDent">{i["Short Value"] || ""}</p>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="_dateNtime _pDate">
                                            <p className="_tblText_inDent">{i["Actule Value"] || ""}</p>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="_dateNtime _pDate">
                                            <p className="_tblText_inDent">{i["Danted"] || ""}</p>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="_dateNtime _pDate">
                                            <p className="_tblText_inDent">{i["Cut Open Value"] || ""}</p>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="_dateNtime _pDate">
                                            <p className={`_tblText_inDent${i?.status == "Not Updated" ? " __rejectTxe" : " __successTxt"}`}>{i?.status || ""}</p>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="_dateNtime _pDate">
                                            <p className="_tblText_inDent">{i?.remark || ""}</p>
                                        </div>
                                    </td>
                                </tr>
                            })}
                        </tbody>
                    </table>
                </div>
            </div>}
        </>
    );
};

export default GanPanelityUpload;
